export default __webpack_public_path__ + "static/media/eduardo-duarte.c13b9154.jpg";